
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you/calendar",
      function () {
        return require("private-next-pages/thank-you/calendar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you/calendar"])
      });
    }
  